(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('giftcard-statement', {
            parent: 'entity',
            url: '/giftcard-statement?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.giftcardStatement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statements.html',
                    controller: 'GiftcardStatementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('giftcardStatement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('giftcard-statement-detail', {
            parent: 'giftcard-statement',
            url: '/giftcard-statement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.giftcardStatement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-detail.html',
                    controller: 'GiftcardStatementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('giftcardStatement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GiftcardStatement', function($stateParams, GiftcardStatement) {
                    return GiftcardStatement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'giftcard-statement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('giftcard-statement-detail.edit', {
            parent: 'giftcard-statement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-dialog.html',
                    controller: 'GiftcardStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GiftcardStatement', function(GiftcardStatement) {
                            return GiftcardStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('giftcard-statement.new', {
            parent: 'giftcard-statement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-dialog.html',
                    controller: 'GiftcardStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                gcClaimCode: null,
                                gcId: null,
                                creationRequestId: null,
                                emailSource: null,
                                emailDestination: null,
                                currencyCode: null,
                                amount: null,
                                balance: null,
                                cardStatus: null,
                                status: null,
                                processed: null,
                                gcExpirationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('giftcard-statement', null, { reload: 'giftcard-statement' });
                }, function() {
                    $state.go('giftcard-statement');
                });
            }]
        })
        .state('giftcard-statement.edit', {
            parent: 'giftcard-statement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-dialog.html',
                    controller: 'GiftcardStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GiftcardStatement', function(GiftcardStatement) {
                            return GiftcardStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('giftcard-statement', null, { reload: 'giftcard-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('giftcard-statement.delete', {
            parent: 'giftcard-statement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-delete-dialog.html',
                    controller: 'GiftcardStatementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GiftcardStatement', function(GiftcardStatement) {
                            return GiftcardStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('giftcard-statement', null, { reload: 'giftcard-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
